var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117 117"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m80.14 11.26-9.68 9.68 26 26 9.68-9.68c5-5 5-13.1 0-18.1l-7.88-7.9c-5-5-13.1-5-18.1 0zm-14.2 14.2L19.32 72.1c-2.08 2.08-3.6 4.66-4.44 7.48L7.8 103.64A4.8 4.8 0 0 0 9 108.4a4.83 4.83 0 0 0 4.74 1.22l24.06-7.08c2.82-.84 5.4-2.36 7.48-4.44l46.66-46.64z"
  })));
};
export default SvgEdit;